import { ContextService } from '../../services/context_service';
import { DateneingabeEnergiedatenEigenstrom } from './DateneingabeEnergiedatenEigenstrom';
import { DateneingabeEnergiedatenEigenwaerme } from './DateneingabeEnergiedatenEigenwaerme';
import { DateneingabeEnergiedatenKennziffern } from './DateneingabeEnergiedatenKennziffern';
import { DateneingabeEnergiedatenKraftstoffe } from './DateneingabeEnergiedatenKraftstoffe';
import { DateneingabeEnergiedatenStrom } from './DateneingabeEnergiedatenStrom';
import { DateneingabeEnergiedatenWaerme } from './DateneingabeEnergiedatenWaerme';
import { DateneingabeEnergiedatenWasser } from './DateneingabeEnergiedatenWasser';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import '../../css/tabs-bereiche.css';
import { DateneingabeBetrieblicheDatenBwlDaten } from './DateneingabeBetrieblicheDatenBwlDaten';
import { DateneingabeBetrieblicheDatenKlimagase } from './DateneingabeBetrieblicheDatenKlimagase';
import { DateneingabeSicherheitszuschlage } from './DateneingabeSicherheitszuschlag';
import { DateneingabeBetrieblicheDatenUniversal } from './DateneingabeBetrieblicheDatenUniversal';

interface DateneingabeEnergiedatenProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    routing: any;
    standortSelected: any;
}

interface DateneingabeEnergiedatenState {
    tabIndex: number;
}

export class DateneingabeEnergiedaten extends
    React.Component<DateneingabeEnergiedatenProps, DateneingabeEnergiedatenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDateneingabeEnergiedaten') || 0,
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDateneingabeEnergiedaten', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const disabledEigenwaerme: boolean = !(this.props.data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.daten_erneuerbare_energien_orig === 1);

        const tabRoutings: Array<any> = [
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_STROM },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_WAERME },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_KRAFTSTOFFE },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_WASSER },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_EIGENSTROM },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_EIGENWAERME },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_KENNZIFFERN },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_BWL_DATEN },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_KLIMAGASE },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_SICHERHEITSZUSCHLAG },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_SCOPE3_TRANSPORT_VORGELAGERT },
            { path: RoutingIDs.ROUTE_ENERGIEDATEN_SCOPE3_GESCHAEFTSREISEN }
        ];

        return (
            <Tabs
                className={'tabs-dateneingabe'}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxDateneingabeEnergiedaten', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{display: 'none'}}>
                    <Tab>Strom</Tab>
                    <Tab>Wärme / Brennstoffe</Tab>
                    <Tab>Kraftstoffe</Tab>
                    <Tab>Wasser / Abwasser</Tab>
                    <Tab>Eigenstrom</Tab>
                    <Tab disabled={disabledEigenwaerme}>Eigenwärme</Tab>
                    <Tab>Gewerkespezifische und eigene Kennzahlen</Tab>
                    <Tab>BWL-Daten</Tab>
                    <Tab>Klimagase</Tab>
                    <Tab>Sicherheitszuschlag</Tab>
                    <Tab>Scope 3.4 - Transport vorgelagert</Tab>
                    <Tab>Scope 3.6 - Geschäftsreisen</Tab>
                </TabList>
                <TabPanel>
                    <DateneingabeEnergiedatenStrom
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeEnergiedatenWaerme
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeEnergiedatenKraftstoffe
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeEnergiedatenWasser
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeEnergiedatenEigenstrom
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeEnergiedatenEigenwaerme
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeEnergiedatenKennziffern
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeBetrieblicheDatenBwlDaten
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeBetrieblicheDatenKlimagase
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeSicherheitszuschlage
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeBetrieblicheDatenUniversal
                        entity={IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel>
                    <DateneingabeBetrieblicheDatenUniversal
                        entity={IDs.ENT_CO2_SCOPE3_REISEN}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
